export const isSuperDownloadButtonEnabled = (): boolean => {
  if (window?.location) {
    const urlParams = new URLSearchParams(window.location.search)
    const superuser = urlParams.get('superdownload')
    return superuser?.toLowerCase() === 'yes'
  }
  return false
}
